'use strict';

function EmailToTaskService(config, $resource) {
  return $resource(config.apiBase + '/companies/:companyId/task-emails/:emailToTaskId', {}, {
    "update": {
      url: config.apiBase + '/companies/:companyId/task-emails/:emailToTaskId',
      method: 'PUT'
    }
  });
}

angular.module('dokiv')
  .factory('EmailToTaskService', ['config', '$resource', EmailToTaskService]);


//////////////////
// WEBPACK FOOTER
// ./scripts/company/email-to-task/EmailToTaskService.js
// module id = 350
// module chunks = 0